// extracted by mini-css-extract-plugin
export default {"button":"ERzlX","icon":"hS2yV"};